<template>
  <div class="loading-view">
   <div class="col-11 col-xl-4 p-0 col-md-6 progress-container">
      <b-col class="col-12 mb-2">
        <b-img :src="require('@/assets/img/logo.png')"/>
      </b-col>

      <b-spinner class="loading-spinner"></b-spinner>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
div.loading-view {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
  margin:0;
  padding: 0;

  .progress-container {
    width: 200px;
    text-align: center;
  }

  .loading-spinner {
    color: var(--color-primary);
    width: 3rem;
    height: 3rem;
  }
}
</style>
